import type { PricePercentile } from '@shared/types/frontend/price-range';
import type { PriceLevel } from '@shared/types/frontend/ubff/price-band';

const getPercentAve = ({
  highPrice,
  indicativePrice,
  lowPrice,
  outlierHigh,
  outlierLow,
  type,
}: {
  lowPrice?: PricePercentile;
  highPrice?: PricePercentile;
  outlierLow?: number;
  outlierHigh?: number;
  indicativePrice?: number;
  type: PriceLevel;
}) => {
  if (
    !indicativePrice ||
    !highPrice ||
    !lowPrice ||
    !outlierHigh ||
    !outlierLow
  ) {
    return 0;
  }
  const ceilObject = {
    indicative: Math.ceil(indicativePrice),
    outlierLow: Math.ceil(outlierLow),
    outlierHigh: Math.ceil(outlierHigh),
    priceHigh: Math.ceil(highPrice.price),
    priceLow: Math.ceil(lowPrice.price),
  };

  const { percentile: percentHigh } = highPrice;
  const { percentile: percentLow } = lowPrice;

  if (ceilObject.indicative <= ceilObject.outlierLow) return 0;
  if (ceilObject.indicative >= ceilObject.outlierHigh) return 100;

  switch (type) {
    case 'PRICE_LEVEL_TYPICAL': {
      const priceRange = ceilObject.priceHigh - ceilObject.priceLow;
      const percentRange = percentHigh - percentLow;
      const positionInRange =
        (ceilObject.indicative - ceilObject.priceLow) / priceRange;
      return percentLow + positionInRange * percentRange;
    }
    case 'PRICE_LEVEL_LOW': {
      const lowRange = ceilObject.priceLow - ceilObject.outlierLow;
      const positionInLowRange =
        (ceilObject.indicative - ceilObject.outlierLow) / lowRange;
      return positionInLowRange * percentLow;
    }
    default: {
      // PRICE_LEVEL_HIGH
      const highRange = ceilObject.outlierHigh - ceilObject.priceHigh;
      const positionInHighRange =
        (ceilObject.indicative - ceilObject.priceHigh) / highRange;
      return percentHigh + positionInHighRange * (100 - percentHigh);
    }
  }
};

export { getPercentAve };
